export default "__VITE_ASSET__DJXPDYn0__"